import type { Atalho, Destino, NivelAlerta, Numero } from './overview_scopes'

/** "Bom dia, Cairo" pela hora local; sem nome, só o cumprimento. */
export function saudacao(agora: Date, nome?: string | null): string {
    const h = agora.getHours()
    const cumprimento = h < 5 ? 'Boa noite' : h < 12 ? 'Bom dia' : h < 18 ? 'Boa tarde' : 'Boa noite'
    const primeiro = `${nome ?? ''}`.trim().split(/[\s@.]+/)[0]
    return primeiro ? `${cumprimento}, ${primeiro.charAt(0).toUpperCase()}${primeiro.slice(1)}` : cumprimento
}

/** "segunda-feira, 26 de outubro" */
export function dataPorExtenso(agora: Date): string {
    return agora.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' })
}

export function valorDoNumero(n: Pick<Numero, 'valor' | 'percentual'>): string {
    return n.percentual ? `${n.valor.toLocaleString('pt-BR')}%` : n.valor.toLocaleString('pt-BR')
}

export const ROTULO_DO_NIVEL: Record<NivelAlerta, string> = {
    erro: 'Resolver agora',
    atencao: 'Atenção',
    info: 'Para acompanhar'
}

export const NOME_DO_DESTINO: Record<Destino, string> = {
    dashboards: 'Dashboards',
    campanha: 'Campanhas',
    cadastroLote: 'Cadastro em Lote',
    grupoManual: 'Grupos manuais',
    bloqueios: 'Bloqueio de números',
    templates: 'Templates do WhatsApp',
    mensagemDireta: 'Mensagem direta',
    simulador: 'Simulador do WhatsApp'
}

const DESCRICAO: Record<Destino, string> = {
    dashboards: 'Consultas, negócios, parceiros e a operação da LIA.',
    campanha: 'Comunicados em massa aos parceiros pelo WhatsApp.',
    cadastroLote: 'Cadastro de vários CNPJs de uma vez para um parceiro.',
    grupoManual: 'Grupos econômicos montados à mão.',
    bloqueios: 'Corte o WhatsApp da LIA para números que abusam do canal.',
    templates: 'Os templates da Meta e o texto de cada mensagem da LIA.',
    mensagemDireta: 'Um recado da AG a um parceiro, pela LIA.',
    simulador: 'Converse com a LIA como se fosse um parceiro.'
}

/** Os atalhos, na ordem do menu, só dos módulos que o papel pode abrir. */
export function atalhosPermitidos(pode: Partial<Record<Destino, boolean>>): Atalho[] {
    return (Object.keys(NOME_DO_DESTINO) as Destino[])
        .filter((d) => pode[d])
        .map((d) => ({ destino: d, nome: NOME_DO_DESTINO[d], descricao: DESCRICAO[d] }))
}

/** O papel acompanha algo que pode virar alerta? (o viewer só vê os números das consultas) */
export function acompanhaAlertas(blocos: readonly string[] | undefined): boolean {
    return (blocos ?? []).some((b) => b !== 'consultas')
}
